import {lazy} from "react";
import {IComponentTypeMapping} from "./ComponentType";

export const ComponentTypeMappings: IComponentTypeMapping = {
    // ========= Dashboard Components ==============
    SparkLineValueIndicator: {
        name: "Spark Line Value Indicator",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/sparkline/SparkLine" /* webpackChunkName: "spark-line" */),
        editorEntryPoint: lazy(() => import("./dashboard/sparkline/SparkLineEditor") /* webpackChunkName: "spark-line-editor" */)
    },
    DatasetCollapseDataTable: {
        name: "Dataset Collapse Data Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-collapse-data-table/DatasetCollapseDataTable" /* webpackChunkName: "dataset-collapse-data-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/dataset-collapse-data-table/dataset-collapse-data-table-editor/DatasetCollapseDataTableEditor") /* webpackChunkName: "dataset-collapse-data-table-editor" */)
    },
    MeasurementDeviceTableAgreg: {
        name: "Measurement Device Table Aggregated",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/measurement-device-table-agreg/MeasurementDeviceTableAgreg" /* webpackChunkName: "measurement-device-table-agreg" */)
    },
    DatasetIndicator: {
        name: "Dataset Gauge Indicator",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-indicator/DatasetIndicator" /* webpackChunkName: "dataset-indicator" */)
    },
    ProductTemplateTable: {
        name: "Product Template Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/product-template-table/ProductTemplateTable" /* webpackChunkName: "product-template-table" */)
    },
    DatasetLineChart: {
        name: "Dataset Line Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/dataset-line-chart/DatasetLineChart" /* webpackChunkName: "dataset-line-chart" */),
        editorEntryPoint: lazy(() => import("./dashboard/charts/dataset-line-chart/DatasetLineChartEditor") /* webpackChunkName: "dataset-line-chart-editor" */)
    },
    DatasetHistogramChart: {
        name: "Dataset Histogram Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/HistogramChart" /* webpackChunkName: "dataset-histogram-chart" */)
    },
    DatasetBarChart: {
        name: "Dataset Bar Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/bar-chart/DatasetBarChartRenderer" /* webpackChunkName: "dataset-bar-chart-renderer" */)
    },
    DatasetScatterChart: {
        name: "Dataset Scatter Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/DatasetScatterChart" /* webpackChunkName: "dataset-scatter-chart" */)
    },
    DatasetPieChart: {
        name: "Dataset Pie Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/DatasetPieChart" /* webpackChunkName: "dataset-pie-chart" */)
    },
    DatasetSankeyChart: {
        name: "Dataset Sankey Chart",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/charts/PlotlySankey/Sankey" /* webpackChunkName: "dataset-sankey-chart" */)
    },
    DataInputOutputTable: {
        name: "Data Input Output Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/data-input-output-table/main-table/DataInputOutputTable" /* webpackChunkName: "data-input-output-table" */),
        editorEntryPoint: lazy(() => import("./dashboard/data-input-output-table/data-input-output-table-editor/DataInputOutputTableEditor") /* webpackChunkName: "data-input-output-table-editor" */)
    },
    Scada: {
        name: "SCADA",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/scada/Scada" /* webpackChunkName: "scada" */)
    },
    DatasetToggleTable: {
        name: "Dataset Toggle Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-toggle-table/DatasetToggleTable" /* webpackChunkName: "dataset-toggle-table" */)
    },
    DatasetSetpointTable: {
        name: "Dataset Setpoint Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-setpoint-table/DatasetSetpointTable" /* webpackChunkName: "dataset-setpoint-table" */)
    },
    DatasetTable: {
        name: "Dataset Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-table/DatasetTable" /* webpackChunkName: "dataset-table" */)
    },
    EapsmLicenceManager: {
        name: "Eapsm License Manager",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/eapsm-license-manager/EapsmLicenseManager" /* webpackChunkName: "eapsm-license-manager" */)
    },
    FreeText: {
        name: "Free Text",
        dashboardComponent: true,
        entryPoint: () => import("./pages/dashboard/components/free-text/FreeText" /* webpackChunkName: "free-text" */)
    },
    GeneratedReportTable: {
        name: "Generated Report Table",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/generated-report-table/GeneratedReportTable" /* webpackChunkName: "generated-report-table" */)
    },
    AlertFan: {
        name: "Alert Fan",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/alert-fan/AlertTabMain" /* webpackChunkName: "alert-fan-tab" */),
        editorEntryPoint: lazy(() => import("./dashboard/alert-fan/AlertFanEditor" /* webpackChunkName: "alert-fan-editor" */))
    },
    Separator: {
        name: "Separator",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/separator/Separator" /* webpackChunkName: "separator" */),
        editorEntryPoint: lazy(() => import("./dashboard/separator/SeparatorEditor") /* webpackChunkName: "separator-editor" */)
    },
    InstantJobEnqueueConfigurator: {
        name: "Instant Job Enqueue Configurator",
        dashboardComponent: true,
        entryPoint: () => import("./company-specific/viking-malt/best-batch-calculator/VikingMaltBestBatchCalculator" /* webpackChunkName: "instant-job-enqueue-configurator" */)
    },
    DevicesMap: {
        name: "Devices Map",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/devices-map/DevicesMap" /* webpackChunkName: "devices-map" */),
    },
    // ==================== Page Fragments ====================
    DashboardComponentConfigurator: {
        name: "Dashboard Component Configurator",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/DashboardComponentConfigurator" /* webpackChunkName: "dashboard-component-configurator" */)
    },
    ProductTemplateConfiguratorJson: {
        name: "Product Template Configurator (JSON)",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/ProductTemplatesConfiguratorJson" /* webpackChunkName: "prod-templates-configurator" */)
    },
    DataWindowChart: {
        name: "Data Window Chart",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/DataWindowChart" /* webpackChunkName: "data-window-chart" */)
    },
    ProductTemplateDataManagerFragment: {
        name: "Product Template Data Manager",
        dashboardComponent: false,
        entryPoint: () => import("./fragments/ProductTemplateDataManagerFragment" /* webpackChunkName: "product-template-data-manager" */)
    },

    EasasGlobalFragment: {
        name: "Global Fragment",
        dashboardComponent: false,
        invisible: true,
        entryPoint: () => import("./fragments/easas-global-fragment/EasasGlobalFragment" /* webpackChunkName: "product-template-data-manager" */)
    },
    // ==================== Pages ====================
    ScheduleBookingPage: {
        name: "ScheduleBookingPage",
        dashboardComponent: false,
        entryPoint: () => import("./pages/schedule-booking/ScheduleBooking" /* webpackChunkName: "schedule-booking" */)
    },
    ScheduledAirflowTaskConfigPage: {
        name: "Scheduled Task Config",
        dashboardComponent: false,
        entryPoint: () => import("./pages/scheduled-task-airflow/AirflowTaskConfigurator" /* webpackChunkName: "scheduled-airflow-task-config-page" */)
    },
    DatasetPage: {
        name: "Datasets",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/dataset-window" /* webpackChunkName: "dataset-window" */)
    },
    DashboardReportsPage: {
        name: "DashboardReportsPage",
        dashboardComponent: false,
        entryPoint: () => import("./pages/dashboard-report/DashboardReportPage" /* webpackChunkName: "dashboard-reports-page" */)
    },
    UserSessionStatsPage: {
        name: "User Session Stats Page",
        "dashboardComponent": false,
        entryPoint: () => import("./pages/users-statistics-dashboard/UsersStatisticsDashboard" /* webpackChunkName: "dashboard-reports-page" */)
    },

    // ========= Dev ==============
    ReactExample: {
        name: "DEV TEST",
        dashboardComponent: true,
        entryPoint: () => import("./dashboard/test/App" /* webpackChunkName: "react-example" */)
    },
    DevSandbox: {
        name: "Dev Sandbox",
        dashboardComponent: true,
        entryPoint: () => import("components/pages/users-statistics-dashboard/UsersStatisticsDashboard" /* webpackChunkName: "dev-sandbox" */)
    },
};